/**
 * @Description 益禾堂外卖额预估
 * https://confluence.lanhanba.com/pages/viewpage.action?pageId=149533541
 */

import { FC } from 'react';
import V2FormInputNumber from '@/common/components/Form/V2FormInputNumber/V2FormInputNumber';

interface EstimateSalesDeliveryProps {
  propertyItem: any;
  required: boolean;
}
const EstimateSalesDelivery: FC<EstimateSalesDeliveryProps> = ({
  propertyItem,
  required,
}) => {
  return (
    <V2FormInputNumber
      label={propertyItem?.anotherName || propertyItem?.name}
      name={propertyItem?.identification}
      placeholder='选择详细地址后自动获取'
      required={required}
      disabled={true}
      config={{
        addonAfter: '元'
      }}
    />
  );
};

export default EstimateSalesDelivery;
